import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DatesharedService {

  constructor() { }

  private editpssharedData: Subject<any> = new Subject<any>();
  editpssharedData$: Observable<any> = this.editpssharedData.asObservable();

  private editpssharedDataExportCall: Subject<any> = new Subject<any>();
  editpssharedDataExportCall$: Observable<any> = this.editpssharedDataExportCall.asObservable();

  private editpssharedDatadetail: Subject<any> = new Subject<any>();
  editpssharedDatadetail$: Observable<any> = this.editpssharedDatadetail.asObservable();

  private editpssharedDatadetailtab: Subject<any> = new Subject<any>();
  editpssharedDatadetailtab$: Observable<any> = this.editpssharedDatadetailtab.asObservable();

  private editpssharedsupplyDatadetail: Subject<any> = new Subject<any>();
  editpssharedsupplyDatadetail$: Observable<any> = this.editpssharedsupplyDatadetail.asObservable();

  editpssetData(updatedData){
    this.editpssharedData.next(updatedData);
  }

  editpssetDataExportCall(){
    this.editpssharedDataExportCall.next(undefined);
  }


  editpssetDatadetailview(updatedDatadetail){
    this.editpssharedDatadetail.next(updatedDatadetail);
  }

  editpssetDatadetailviewtab(updatedDatadetail){
    this.editpssharedDatadetailtab.next(updatedDatadetail);
  }

  editpssupplysetDatadetailview(updatedDatadetail){
    this.editpssharedsupplyDatadetail.next(updatedDatadetail);
  }

}
